<template>
  <div>
    <AuthMenu v-if="loggedIn"></AuthMenu>
    <NoAuthMenu v-if="!loggedIn"></NoAuthMenu>
  </div>
</template>

<script>
import AuthMenu from "@/components/menu/Auth";
import NoAuthMenu from "@/components/menu/NoAuth";

export default {
  name: "SideMenu",
  components: { NoAuthMenu, AuthMenu }
};
</script>
